import * as API from '../../../data/user_api';
import React, { Component } from 'react'
import { Segment, Header, Form, Button,List,Icon,Message } from "semantic-ui-react"
import { update, updateProfileById } from "../../../data/user_api";
import { CLERK_API_URL,COMPANY_API_URL } from "../../../constants/api_routes";
import Loader from "../../universal/loader"

export default class WeeklyAvailability extends Component {
  constructor (props) {
    super(props);
    this.state = {
      weeklyAvailability:{
        monday: undefined,
        tuesday: undefined,
        wednesday: undefined,
        thursday: undefined,
        friday: undefined,
        saturday: undefined,
        sunday: undefined
      },
      availability_comment: "",
      areas_covered:"",
      isLoading: true,
      excludedCompaniesList: [],
      excludedCompanies: [],
      prefJobNumber:0,
      isUpdating:false
    }
    
  }
  
  componentDidMount() {
  
    this.props.clerkData.clerk_availability_comment != null ? this.setState({ availability_comment: this.props.clerkData.clerk_availability_comment }) : null
    if (this.props.clerkData.weekly_availability != null) {
      let newWeeklyData = null
      try {newWeeklyData = JSON.parse(this.props.clerkData.weekly_availability)}
      catch (e) { newWeeklyData = this.props.clerkData.weekly_availability }
      let currentWeeklyData = { ...this.state.weeklyAvailability }
      Object.keys(currentWeeklyData).map((day) => {
        currentWeeklyData[day] = newWeeklyData[day]
      })
      this.setState({ weeklyAvailability: currentWeeklyData, isLoading:false,prefJobNumber:this.props.clerkData.jobs_per_week })
    }
    this.initializeExcludedCompanies()
    this.setState({ isLoading: false })
    
  }

  handleExcludedCompanySelection = async (company_id) => {
    if (this.state.excludedCompanies.includes(company_id)) {
      var filteredList = this.state.excludedCompanies.filter(function(value, index, arr){ 
        return value != company_id;
      });
      this.setState({excludedCompanies:filteredList})
    }
    else {
      var newList = [...this.state.excludedCompanies, company_id]
      this.setState({excludedCompanies:newList})
      }
    
    
  }

  initializeExcludedCompanies = async () => {
    const response = await API.getListingData(COMPANY_API_URL);
    if(response.status === 401){
        this.setState({excludedCompaniesList:[]})
    }
    else if (response.status === 403) {
      this.setState({ excludedCompaniesList: [] ,excludedCompanies:this.props.clerkData.excluded_companies })
    }
    else 
    {
      this.setState({ excludedCompaniesList: [...response],excludedCompanies:this.props.clerkData.excluded_companies })
    }
  }
  handleSubmit = (event) => {
    this.setState({isUpdating:true})
    event.preventDefault();
    const formData = new FormData();
    formData.append("availability_update", true)
    formData.append("availability_comment", this.state.availability_comment)
    formData.append("areas_covered", this.state.areas_covered)
    formData.append("jobs_per_week", this.state.prefJobNumber)
    formData.append("weekly_availability", JSON.stringify(this.state.weeklyAvailability))
    for (let i = 0; i < this.state.excludedCompanies.length;i++) {
      formData.append("excluded_companies[]", this.state.excludedCompanies[i])
    }
    updateProfileById(CLERK_API_URL, this.props.clerkData.id, formData).then(() => {

      this.props.callbackFn();
      window.location.reload()
    })
  }
  render() {
    const userRole = JSON.parse(localStorage.getItem('user'))['role'];
    let availablity_options = [{key: 0, text: "Not Defined", value: null}, {key: 1, text: "Available", value: 1},{key:2,text: "Partially Available",value:2},{key:3,text: "Unavailable",value:3}];
    return (!this.state.isLoading ?<Segment textAlign="center">
        <div style={{ width: "100%" }}>
          <Form onSubmit={this.handleSubmit}>
              <Button disabled={this.state.isUpdating} loading={this.state.isUpdating} primary >Update Availability Info</Button>
              <Header> Availability Comment</Header>
              <Form.TextArea
                defaultValue={this.props.clerkData.clerk_availability_comment}
                style={{ minHeight: 80 }}
            onChange={(e) => { this.setState({ availability_comment: e.target.value }); }} />
            <Message>Keep the Availability Comment updated if your availability changes weekly and you don't work set days every week or you have other special considerations (e.g Can only work till 2:30pm every day). <br/>NOTE: <b style={{color:"red"}}>Do not set your leaves here if you have set days you work each week.</b> If you work the same days every week. Set those in the dropdowns below and then use the Mark Leave / Availability to schedule days off.</Message>
                    <Header> Weekly Availability Details</Header>
          {Object.keys(this.state.weeklyAvailability).map((day) => {
            return <div key={day}><span key={day}className="format-bold half-wide" style={{ textTransform: "capitalize" }}>{day}</span>
              <span className="half-wide"><Form.Dropdown selection
                placeholder="Not Defined"
                fluid
                options={availablity_options}
                defaultValue={this.state.weeklyAvailability[day]}
                onChange={(e, option) => {
                  let newWeeklyAvailability = { ...this.state.weeklyAvailability };
                  newWeeklyAvailability[day] = option.value;
                  this.setState({ weeklyAvailability: newWeeklyAvailability })
                }}>
              </Form.Dropdown >
              </span></div>})}
              <Header> Preferred Job Number (Per Week)</Header>
              <Form.Input type="number" min={0}
                value={this.state.prefJobNumber}
            onChange={(e) => { this.setState({ prefJobNumber: e.target.value }); }} />
                      <Header> Areas Covered</Header>
              <Form.TextArea
                defaultValue={this.props.clerkData.areas_covered}
                style={{ minHeight: 80 }}
              onChange={(e) => { this.setState({ areas_covered: e.target.value }); }} />
            <Button disabled={this.state.isUpdating} loading={this.state.isUpdating} primary >Update Availability Info</Button>
          </Form>
      </div>
{userRole === "admin" && <Segment>
      <Header>Excluded Companies</Header>
      <div style={{ width: "100%" }}>
        <List selection>
          {this.state.excludedCompaniesList.map(comp =>{return <List.Item  onClick={()=> this.handleExcludedCompanySelection(comp.id)} key={comp.id}>
            <List.Content>
              <List.Header>{this.state.excludedCompanies.includes(comp.id) ? <Icon color="red" name="close"/> : <Icon color="green" name="check"/>}
                {comp.name}</List.Header>
      </List.Content>
    </List.Item>})}
        </List>
        <Button onClick={this.handleSubmit } primary>Update Excluded Companies</Button>
      </div></Segment>}
    </Segment> : <Loader contain={true}></Loader>
      
    
        )
  }
}



// WEBPACK FOOTER //
// ./src/views/user/clerk/weekly_availability.js